let EVENT_TYPES = {
  APPOINTMENT_BOOKING_STATE_UPDATE: 'AppointmentBookingStateUpdate',
  TREATMENT_STATUS_UPDATE: 'TreatmentStatusUpdate',
  RESOURCE_INSERT: 'ResourceInsert',
}

export function getView(event_type) {
  return EVENT_TYPES[event_type] || 'No'
}
